import { Box, Modal } from '@mui/material';

type ProceedModalProps = {
  visible: boolean;
  setShowModal: (bol: boolean) => void;
  setBluredImage: (bol: boolean) => void;
};

export const ProceedModal = ({
  visible,
  setShowModal,
  setBluredImage,
}: ProceedModalProps) => {
  const handleCloseModal = () => {
    setShowModal(false);
    setBluredImage(true);
    localStorage.setItem('imageBlured', 'true');
  };

  const handleCloseAndRemember = () => {
    setShowModal(false);
    localStorage.setItem('proceedModalDismissed', 'true');
    setBluredImage(false);
  };

  return (
    <Modal
      open={visible}
      closeAfterTransition
      sx={{
        display: 'flex',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        '&.MuiBox-root': {
          border: 'none',
        },
        '&:focus': {
          outline: 'none',
        },
      }}
    >
      <Box
        sx={{
          '&:focus': {
            outline: 'none',
          },
        }}
      >
        <div className="m-4 flex h-auto w-[400px] max-w-screen-lg flex-col overflow-y-auto rounded-lg bg-base-100 px-6 py-0">
          <div className="sticky top-0 z-[51] mb-8 flex w-full flex-col bg-base-100 pt-2">
            <div className="grow text-center text-xl">⚠️ Warning</div>
          </div>

          <p className="text-base text-center mb-2">
            This image, while present in many high school history books, may be
            considered disturbing in nature.
          </p>
          <p className="text-base text-center font-bold mb-8">
            Would you like to see it?
          </p>

          <div className="flex flex-row gap-2 mb-4">
            <button
              type="button"
              onClick={handleCloseModal}
              className={`btn btn-outline w-full shrink text-md md:h-[61px]`}
            >
              No, I’ll guess blind
            </button>

            <button
              type="button"
              onClick={handleCloseAndRemember}
              className={`btn btn-primary w-full shrink text-md md:h-[61px]`}
            >
              Yes, show me the image
            </button>
          </div>
        </div>
      </Box>
    </Modal>
  );
};
